var upLogin;

$(document).ready(function(){
	upLogin = new UpLogin();
	
	upLogin.init();
});